import { AnnouncementAttachments } from '../announcements/models';
import { Comment } from '../shared/comments/models';
import { Users } from '../shared/forms';
import { BaseToolbarNavList, TasksLegendModal } from '../views';
import { ImagePreviewModal } from '../../backbone/shared/views/ImagePreviewModal';
import { BaseToolbarNavPageLayout } from '../../backbone/shared/views/baseLayoutViews';
import { CommentsForUser } from './models';
import { BaseTabbedLayoutPage } from '../../backbone/shared/views/tabs';
import { ModalOptionsView } from '../../backbone/shared/views/ModalOptionsView';
import { EmptyListMessage } from '../../backbone/shared/views/EmptyListMessage';
import { CordovaPlugins, getZencamLocalizedStrings } from '../../shared/CordovaPlugins';
import {
    actionSheet,
    hideLoadingDialog,
    showSuccessMessage,
    showLoadingDialog,
    showErrorMessage,
    toastNotification
} from '../../shared/utils/notifications';
import { isConnected, isIos, isWeb } from '../../shared/utils/is';
import { logMobileUsage } from '../../shared/utils/mobileUsageLogging';

export const CommentDeleted = Backbone.Marionette.Layout.extend({
    template: '#tpl_comment_deleted',

    templateHelpers: function () {
        return {
            message: _t('mobile_comments_comment_deleted')
        };
    }
});

export const MobileCommentTaskSubmitted = Backbone.Marionette.Layout.extend({
    template: '#tpl_comment_task_submitted',
    model: null, // Comment
    tagName: 'li',
    className: 'comment',

    templateHelpers: function () {
        var date_string = moment(this.model.get('date_created')).format($f.utils.DATE_FMT);
        var time_string = moment(this.model.get('date_created')).format($f.utils.TIME_FMT);
        return {
            event_text: _t('mobile_comments_task_submitted_at', { date: date_string, time: time_string })
        };
    }
});

export const MobileCommentItem = Backbone.Marionette.Layout.extend({
    template: '#tpl_comment',
    model: null, // Comment
    tagName: 'li',
    className: 'comment',
    _gestures: null, // an instance of Hammer Plugin for gestures

    events: {
        'click .delete': 'delete_comment'
    },

    regions: {
        r_deleted: '.comment_deleted'
    },

    templateHelpers: function () {
        var user = this.model.get('created_user');

        return {
            display_name: user.display_name,
            user_role: user.user_role ? user.user_role.name : '',
            date_displayed: moment(this.model.get('date_created')).format($f.utils.DATE_AND_TIME_NO_TZ_FMT),
            is_active: this.model.get('is_active'),
            show_delete: this.model.get('is_active') && user.id === $f.active_user.id,
            formatted_message: this.model.get_html_formatted_message({
                for_editing: false,
                disable_clicking: true
            })
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    onBeforeRender: function () {
        this._destroy_gestures();
    },

    onRender: function () {
        if (!this.model.get('is_active')) {
            this.r_deleted.show(new CommentDeleted());
            return;
        }

        this.r_deleted.close();
        this._enable_swipe_to_delete();
    },

    onBeforeClose: function () {
        this._destroy_gestures();
    },

    delete_comment: function (event) {
        event.preventDefault();

        var this_ = this;
        var _text_title = _t('mobile_comments_delete_comment_title');
        var _text_confirm_message = _t('mobile_comments_delete_confirm_message');
        var _text_button_delete_comment = _t('mobile_comments_delete_button');
        var _text_button_cancel = _t('mobile_action_sheet_cancel');

        var button_rect = this.$el.find('.delete_container').get(0).getBoundingClientRect();

        var _decide_callback = function (button_index) {
            if (_.contains([2, 3], button_index)) {
                // for close or clicking away
                this_.$el.removeClass('deleting'); // hide swipe to delete
                return; // cancel
            }

            this_.model.delete({
                success: function () {
                    showSuccessMessage(_t('mobile_comments_delete_success_message'));
                    this_.render();
                },
                error: function () {
                    showErrorMessage();
                }
            });
        };

        if (isWeb()) {
            return $f.application.content_overlay.show(
                new ModalOptionsView({
                    text: _text_confirm_message,
                    top: '20%',
                    right: 0,
                    buttons: [_text_button_delete_comment, _text_button_cancel],
                    callback: _decide_callback
                })
            );
        }

        var options = {
            title: _text_title,
            subtitle: _text_confirm_message,
            position: [button_rect.left - 20, button_rect.top + 20], // only used for iPad
            buttonLabels: [_text_button_delete_comment], // android & windows
            androidEnableCancelButton: true,
            destructiveButtonLast: true, // iOS
            androidTheme: CordovaPlugins().actionsheet.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT,
            addCancelButtonWithLabel: _text_button_cancel // for ios, this is what enables clicking away to close modal
        };

        actionSheet(options, _decide_callback);
    },

    _enable_swipe_to_delete: function () {
        /* @author: halah due to the following reason, panning is used to display delete on mobile web
            and swiping is used to display delete on native:
            Swiping is not easily detced on mobile
            Swiping does not work on mobile web desktop
            To accommodate that, & taking into consideration debugging/developers, I went with panning for mobile web
            Unfortunately, panning is triggered on scrolling with native &
            swiping is fine for native & is not triggered on scroll so swiping is used for native
        */
        var $element = this.$el;
        var this_ = this;

        this._gestures = new Hammer($element.get(0));
        this._hide_delete_button();

        if (isWeb()) {
            this._gestures.get('swipe').set({ enable: false });
            this._gestures.get('pan').set({
                enable: true,
                direction: Hammer.DIRECTION_HORIZONTAL
            });

            this._gestures.on('panleft', function (event) {
                event.preventDefault();
                this_._show_delete_button();
            });

            this._gestures.on('panright', function (event) {
                event.preventDefault();
                this_._hide_delete_button();
            });

            return;
        }

        this._gestures.get('pan').set({ enable: false });
        this._gestures.get('swipe').set({
            enable: true,
            direction: Hammer.DIRECTION_HORIZONTAL
        });

        this._gestures.on('swipeleft', function (event) {
            event.preventDefault();
            this_._show_delete_button();
        });

        this._gestures.on('swiperight', function (event) {
            event.preventDefault();
            this_._hide_delete_button();
        });

        return;
    },

    _show_delete_button: function () {
        this.$el.addClass('deleting');
    },

    _hide_delete_button: function () {
        this.$el.removeClass('deleting');
    },

    _destroy_gestures: function () {
        this._hide_delete_button();

        if (!this._gestures) {
            return;
        }

        this._gestures.destroy();
    }
});

export const MobileCommentsList = Backbone.Marionette.CollectionView.extend({
    template: '#tpl_comments',
    collection: null, // Comments
    tagName: 'ul',
    className: 'comments pagelist',

    getEmptyView: function () {
        var translation_key = 'mobile_comments_empty_message_default';

        if (this.collection && this.collection.target.get('type') === 'task') {
            translation_key = 'mobile_comments_empty_message_tasks';
        } else if (this.collection && this.collection.target.get('type') === 'submission') {
            translation_key = 'mobile_comments_empty_message_submissions';
        }

        return EmptyListMessage.extend({
            image_filename: 'comments_downstate.svg',
            i18n_key_message: _t(translation_key),
            icon_class: null
        });
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
        var this_ = this;
        this.collection.add_event_models();

        this.listenTo(this.collection, 'add', function () {
            this_._scroll_down_to_last_comment();
        });
    },

    onShow: function () {
        this._scroll_down_to_last_comment();
    },

    getItemView: function (model) {
        if (!model.get('is_task_submitted')) {
            return MobileCommentItem;
        }

        return MobileCommentTaskSubmitted;
    },

    _scroll_down_to_last_comment: function () {
        if (!this.collection.length) {
            return;
        }

        setTimeout(function () {
            var $page_scrollable = $('.comments_list');

            var distance =
                $('.comments_list li').last().offset().top +
                $page_scrollable.scrollTop() +
                $page_scrollable.offset().top;
            $page_scrollable.animate({ scrollTop: distance });
        }, 100);
    }
});

export const UserToNotify = Backbone.Marionette.ItemView.extend({
    template: '#tpl_user_to_notify',
    tagName: 'li',

    templateHelpers: function () {
        var user_role = this.model.get('user_role');

        if (user_role && typeof user_role === 'object') {
            user_role = user_role.name;
        }

        return {
            user_role: user_role
        };
    }
});

export const UsersList = Backbone.Marionette.CollectionView.extend({
    template: '#tpl_users_to_notify',
    className: 'modal_list',
    tagName: 'ul',
    itemView: UserToNotify,

    getEmptyView: function () {
        return EmptyListMessage.extend({
            icon_class: null,
            i18n_key_message: _t('mobile_comments_empty_users_to_notify')
        });
    }
});

export const UsersToNotifyLayout = Backbone.Marionette.Layout.extend({
    template: '#tpl_users_to_notify_layout',
    subscribers: null, // Users()
    inactive_mentions: null, // Users()

    regions: {
        r_subscribers: '.subscribers',
        r_inactive_mentions: '.inactive_mentions'
    },

    templateHelpers: function () {
        return {
            show_inactive_mentions: this.inactive_mentions && this.inactive_mentions.length !== 0,
            title: _t('mobile_comments_users_cant_view_message')
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    onRender: function () {
        this._show_subscribers();
        this._show_inactive_mentions();
    },

    _show_subscribers: function () {
        this.r_subscribers.show(
            new UsersList({
                collection: this.subscribers
            })
        );
    },

    _show_inactive_mentions: function () {
        if (!this.inactive_mentions) {
            return;
        }

        this.r_inactive_mentions.show(
            new UsersList({
                collection: this.inactive_mentions
            })
        );
    }
});

export const UsersToNotifyModal = Backbone.Marionette.Layout.extend({
    template: '#tpl_users_to_notify_modal',
    title: null,
    description: null,
    _close_trigger_els: null, // used internally by _setup_close_events() and _destroy_close_events()
    subscribers: null, // Users()
    inactive_mentions: null, // Users()

    ANIMATION_TIME_MS: 500,

    attributes: {
        id: 'users_to_notify_modal'
    },

    regions: {
        r_modal_body: '.modal_body'
    },

    templateHelpers: function () {
        return {
            title: this.title
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        if (!this.title) {
            throw new Error('Programmer Error: UsersToNotifyModal must have a title');
        }
    },

    onRender: function () {
        this._setup_close_events();
        this._show_modal_body();
    },

    onShow: function () {
        var this_ = this;

        // add backdrop when modal is opened and close modal when touching outside of it
        $f.mobile.nav.show_modal_touchblock({ duration: this_.ANIMATION_TIME_MS }, function () {
            this_.close();
            // fade the actual modal in too
            this_.$el.css('opacity', 0);
            this_.$el.velocity({ opacity: 1 }, { duration: this_.ANIMATION_TIME_MS / 2 });
        });
    },

    close: function () {
        var args_ = arguments;
        var this_ = this;

        this._destroy_close_events();

        $f.mobile.nav.hide_modal_touchblock({ duration: this_.ANIMATION_TIME_MS });
        // fade us out and then close
        this_.$el.velocity(
            { opacity: 0 },
            {
                duration: this.ANIMATION_TIME_MS / 2,
                complete: function () {
                    TasksLegendModal.__super__.close.apply(this_, args_);
                }
            }
        );
    },

    /**
     * Instead of using Bootstrap's method of closing on any data-dismiss=modal attribute or its .modal-backdrop,
     * let's handle the event ourselves through events and backbone. Instead of using this.events here,
     * we'll use .on() and .off() so our subclasses don't have to worry about extending this.events.
     */
    _setup_close_events: function () {
        var this_ = this;
        this._close_trigger_els = this.$el.find('.modal_footer .close_modal');

        // remove bootstrap's default click behavior for backdrop as well as any events we already set up
        this._destroy_close_events();

        // set up the close button and backdrop to call close()
        this._close_trigger_els.on('click', function (event) {
            this_.close(event);
        });
    },

    _destroy_close_events: function () {
        this._close_trigger_els.off('click');
    },

    _show_modal_body: function () {
        this.r_modal_body.show(
            new UsersToNotifyLayout({
                subscribers: this.subscribers,
                inactive_mentions: this.inactive_mentions
            })
        );
    }
});

export const MobileMentionsSummary = Backbone.Marionette.Layout.extend({
    template: '#tpl_mentions_summary',
    model: null, // $f.web.components.comments.models.Comment
    collection: null, // Comments

    events: {
        'click .show_users_to_notify': 'show_users_to_notify'
    },

    templateHelpers: function () {
        var notify_count = this.model.get('target').get_users_to_notify_count_for_display();

        // @jira:ZP-734 i18next should automatically do this, but it's broken with our implementation
        var notifiers_translation_key =
            notify_count === 0 || notify_count > 1
                ? 'mobile_comments_mention_description_notifiers_plural'
                : 'mobile_comments_mention_description_notifiers';

        return {
            mention_description_text: _t(notifiers_translation_key, { count: notify_count })
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
        var this_ = this;
        var mentioned = new Users(); // Used to track which users were added in the comment text area.
        var target = this.model.get('target');

        // Update subscribers when new mentions are added
        this.listenTo(this.model.get('mentions'), 'add', function (to_add) {
            target.add_subscribers(to_add, mentioned);
        });
        // Remove user from the subscribers collection, but only if they were
        // added into the comment text area.
        this.listenTo(this.model.get('mentions'), 'remove', function (to_remove) {
            target.remove_subscribers(to_remove, mentioned);
        });
        // when mentions change, update our count
        this.listenTo(this.model.get('mentions'), 'add change remove', this_.render);
    },

    show_users_to_notify: function (event) {
        event.preventDefault();

        $f.application.content_overlay.show(
            new UsersToNotifyModal({
                title: _t('mobile_comments_users_to_notify_title'),
                subscribers: this.model.get('target').get_users_to_notify_for_display(),
                inactive_mentions: this.collection.inactive_mentions
            })
        );
    }
});

export const MobileCommentCreator = Backbone.Marionette.Layout.extend({
    template: '#tpl_comment_creator',
    className: 'creator_layout',
    collection: null, // Comments
    model: null, // Comment
    task: null,
    submission: null,
    comment_content: '',
    _tribute: null, // Tribute mention autocomplete instance, @see _init_mentions_typeahead()
    _autocomplete_users: null, // Users - collection used for serverside search of mentions
    _autocomplete_users_tribute: null,
    _is_sending: false,
    is_mentions_list_open: false,

    events: {
        'click .send_comment': 'send_comment',
        'click .r_mentions_summary .open_mention_autocomplete': 'open_mention_autocomplete',
        'click .open_mentions': 'open_mention_autocomplete',
        'keydown .comment_field': 'on_field_keydown',
        'keyup .comment_field': 'on_field_keyup',
        'paste .comment_field': 'sanitize_comment_pasted_html'
    },

    regions: {
        r_mentions_summary: '.mentions_summary'
    },

    templateHelpers: function () {
        return {
            placeholder: _t('mobile_comments_comment_placeholder'),
            max_length: $f.shared.comments.utils.COMMENT_MAX_LENGTH,
            comment_content: this.model.get_html_formatted_message({
                for_editing: true,
                disable_clicking: true
            })
        };
    },

    initialize: function (options) {
        var this_ = this;
        options = options || {};
        $.extend(this, options);

        this.model = this._create_new_comment();
        this._autocomplete_users = new Users();
        this._autocomplete_users.paginator.set('override_hierarchy_restriction', true);

        this._autocomplete_users.fetch({
            success: function () {
                this_._autocomplete_users_tribute = this_._autocomplete_users.to_tribute_autocomplete();
            }
        });

        this.listenTo($f.application.vent, 'comments_tab:go_back:post_comment', function () {
            this_._go_back();
        });
    },

    onBeforeRender: function () {
        this._destroy_tribute();
        this.stopListening(this.model.get('mentions'), 'change');
        this.listenTo(
            this.model.get('mentions'),
            'change',
            function (mention) {
                // eslint-disable-next-line no-prototype-builtins
                if (!mention.changed.hasOwnProperty('is_subscriber')) {
                    // The is_subscriber property has not changed
                    return;
                }
                if (mention.get('is_subscriber')) {
                    // is_subscriber was changed, but the obj is allowed to read
                    // so leave mention blue.
                    return;
                }
                // Make the mention inactive
                var el = this.$el.find(`.tribute-mention[data-id=${mention.get('id')}]`);
                el.addClass('mention_inactive');
            }.bind(this)
        );
    },

    onBeforeClose: function () {
        this._destroy_tribute();
    },

    onRender: function () {
        this._init_mentions_typeahead();
        this._show_mentions_summary();
    },

    open_mention_autocomplete: function (event) {
        event.preventDefault();
        if (this.is_mentions_list_open) {
            this.is_mentions_list_open = false;
            return;
        }

        this.is_mentions_list_open = true;
        this._tribute.showMenuForCollection(this.$el.find('.comment_field').get(0));
    },

    on_field_keyup: function (event) {
        $f.shared.comments.utils.fix_corrupted_mention_html(this.$el.find('.comment_field'));

        var html = this._get_pending_html_value();
        this.model.set_message_from_html(html); // in case we need to re-render
        this.model.set_mentions_from_html(html); // update the count in r_mentions_summary

        if (!html || this._is_sending) {
            this._disable_send_button();
            return;
        }

        this._enable_send_button();
    },

    on_field_keydown: function (event) {
        // cmd/ctrl+enter sends comment
        if (
            this._get_pending_html_value() &&
            event.keyCode === $f.shared.comments.utils.KEYCODE_ENTER &&
            (event.ctrlKey || event.metaKey)
        ) {
            this.send_comment(event);
            return false;
        }

        if (!this._is_keypress_allowed(event, this.$el.find('.comment_field').text())) {
            return false;
        }

        return true;
    },

    /**
     * Removes formatting and trims pasted values.
     */
    sanitize_comment_pasted_html: function (event) {
        event.preventDefault();
        $f.shared.comments.utils.sanitize_comment_pasted_html(event);
    },

    send_comment: function (event) {
        event.preventDefault();
        var this_ = this;

        var html = this._get_pending_html_value();
        this.model.set_message_from_html(html);
        this.model.set_mentions_from_html(html);

        this._is_sending = true;
        this._disable_send_button();

        this.collection.add_comment(this.model, {
            success: function () {
                this_._on_comment_added();
                this_._is_sending = false;
            },
            error: function () {
                this_._enable_send_button();
                this_._is_sending = false;
                showErrorMessage();
            }
        });

        return false;
    },

    _enable_send_button: function () {
        var $send_button = this.$el.find('.send_comment');

        if (!$send_button.attr('disabled')) {
            return;
        }

        this.$el.find('.send_comment').removeAttr('disabled');
    },

    _disable_send_button: function () {
        this.$el.find('.send_comment').attr('disabled', 'disabled');
    },

    _on_comment_added: function () {
        var $comment_textarea = this.$el.find('.comment_field');

        $comment_textarea.val('');
        this.comment_content = '';

        this.model = this._create_new_comment();
        this._disable_send_button();

        this.render();
    },

    _create_new_comment: function () {
        return new Comment({
            target: this.collection.target
        });
    },

    _get_pending_html_value: function () {
        var $field = this.$el.find('.comment_field');

        if (!$field.text() && $field.html()) {
            return '';
        }

        return $field.html();
    },

    _init_mentions_typeahead: function () {
        var this_ = this;
        var active_query = '';
        var _timeout = null;

        this._tribute = new window.Tribute({
            trigger: '@',
            menuContainer: this.$el.get(0),
            values: function (query, callback) {
                this_.is_mentions_list_open = true;
                active_query = query;

                if (_timeout) {
                    window.clearTimeout(_timeout); // cancel our last request in favor of this one
                }

                _timeout = setTimeout(function () {
                    if (!query) {
                        callback(this_._autocomplete_users_tribute);
                    } else {
                        this_._autocomplete_users.typeahead_search(query, function () {
                            callback(this_._autocomplete_users.to_tribute_autocomplete());
                        });
                    }
                }, $f.shared.comments.utils.FETCH_FREQUENCY_MS);
            },
            noMatchTemplate: function () {
                if (!active_query) {
                    return ''; // don't show this message if the user hasn't searched for anything
                }

                return `<li class="no_users">${_t('mobile_comments_no_matching_users')}</li>`;
            },
            selectTemplate: function (item) {
                if (!item) {
                    return null; // when there are no sugestions, and if enter is pressed, item is not set.
                }
                this_.is_mentions_list_open = false;

                var mention = this_.model.get('mentions').get(item.original.id);
                this_._enable_send_button();
                return Comment.get_mention_span({
                    id: item.original.id,
                    display: item.original.value,
                    user_role: item.original.user_role,
                    is_subscriber: mention ? mention.get('is_subscriber') : true
                });
            }
        });

        this._tribute.attach(this.$el.find('.comment_field').get(0));
    },

    _show_mentions_summary: function () {
        this.r_mentions_summary.show(
            new MobileMentionsSummary({
                model: this.model,
                collection: this.collection
            })
        );
    },
    /**
     * Determine if the keypresses are allowed, based on our character limit.
     * We need to do this because we're using a contenteditable <p> instead of a traditional <textarea> to allow
     * styling for @mentions.
     *
     * @see https://stackoverflow.com/a/55274684/477632
     *
     * @param {Event}   event       The keydown event
     * @param {string}  text_value  The current text value of the input box
     */
    _is_keypress_allowed: function (event, text_value) {
        if (text_value.length <= $f.shared.comments.utils.COMMENT_MAX_LENGTH) {
            return true;
        }

        if (_.contains($f.shared.comments.utils.ALLOWED_KEYCODES, event.which)) {
            return true;
        }

        if (event.ctrlKey || event.metaKey) {
            // ctrl or cmd
            return true;
        }

        return false;
    },

    _go_back: function () {
        var this_ = this;
        var _text_title = _t('mobile_comments_discard_comment_title');
        var _text_confirm_message = _t('mobile_comments_discard_confirm_message');
        var _text_button_discard = _t('mobile_common_button_discard');
        var _text_button_cancel = _t('mobile_action_sheet_cancel');

        this.comment_content = this._get_pending_html_value();
        /* stripping empty spaces after getting the text.
         * For some reason on mobile, the HTML value is "[empty lines]"
         * & when you click go back, HTML value is not empty & that triggers the Post Comment Modal to be displayed
         */

        var _decide_callback = function (button_index) {
            if (_.contains([2, 3], button_index)) {
                return; // cancel
            }

            this_.model.restore(); // discard
            $f.mobile.nav.go_back();
        };

        if (!this.comment_content) {
            return $f.mobile.nav.go_back();
        }

        if (isWeb()) {
            return $f.application.content_overlay.show(
                new ModalOptionsView({
                    text: _text_confirm_message,
                    top: '20%',
                    right: 0,
                    buttons: [_text_button_discard, _text_button_cancel],
                    callback: _decide_callback
                })
            );
        }

        var options = {
            title: _text_title,
            subtitle: _text_confirm_message,
            position: [50, 60], // only used for iPad
            buttonLabels: [_text_button_discard], // android & windows
            androidEnableCancelButton: true,
            destructiveButtonLast: true, // iOS
            androidTheme: CordovaPlugins().actionsheet.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT,
            addCancelButtonWithLabel: _text_button_cancel // for ios, this is what enables clicking away to close modal
        };

        actionSheet(options, _decide_callback);
    },

    /**
     * Deactivate and detach the tribute mention autocomplete. Without this, the page will generate a new autocomplete
     * with each render or reinitialization.
     */
    _destroy_tribute: function () {
        if (!this._tribute) {
            return;
        }

        this._tribute.detach(this.$el.find('.comment_field'));
    }
});

export const CommentsTab = BaseTabbedLayoutPage.extend({
    template: '#tpl_comments_tab',
    collection: null, // Comments

    _POSITION_BOTTOM_KEYBOARD_OPEN: function () {
        return $f.mobile.keyboard_height;
    },

    _POSITION_BOTTOM_KEYBOARD_CLOSE: '0px',
    _ANIMATION_SPEED: 150,

    regions: {
        r_comments_list: '.comments_list',
        r_comment_creator: '.comment_creator'
    },

    initialize: function () {
        var this_ = this;
        CommentsTab.__super__.initialize.apply(this, arguments);

        this.listenTo($f.application.vent, 'comments_tab:on_orientation_change', function () {
            this_._toggle_comment_input_field_position();
        });
    },

    on_tab_focused: function () {
        var this_ = this;
        if (!this.collection || !this.collection.has_unread_comments()) {
            this_._show_regions();
            return;
        }

        this.collection.mark_all_as_read({
            success: function () {
                $f.mobile.unread_notifications_count.fetch();
                this_._show_regions();
            },
            error: function () {
                showErrorMessage();
                this_._show_regions();
            }
        });
    },

    _show_regions: function () {
        this._show_comments_list();
        this._show_comment_creator();

        // Need to update .page_scrollable sizing now that we've updated the page with more content
        $f.mobile.update_page_scrollable_height(this.$el);
    },

    _show_comments_list: function () {
        this.r_comments_list.show(new MobileCommentsList({ collection: this.collection }));
    },

    _show_comment_creator: function () {
        if (!isConnected()) {
            return;
        }

        this.r_comment_creator.show(
            new MobileCommentCreator({
                collection: this.collection,
                task: this.collection.target.get('instance'),
                submission: this.submission
            })
        );
    },

    _toggle_comment_input_field_position: function () {
        this._close_all_delete_buttons();

        if (!isIos() || isWeb()) {
            // this is only necessary for iOS; Android handles this magically
            return;
        }

        if (this.$el.find('.comment_field:focus').length) {
            this._slide_comment_input_field_up();
            return;
        }

        this._slide_comment_input_field_down();
    },

    _slide_comment_input_field_up: function () {
        var this_ = this;
        var $comment_creator_layout = this.$el.find('.comment_creator .creator_layout');
        var $editable_container = $('.editable_container');
        $comment_creator_layout.animate(
            {
                bottom: this._POSITION_BOTTOM_KEYBOARD_OPEN()
            },
            this._ANIMATION_SPEED,
            function () {
                $editable_container.css({
                    bottom: this_._POSITION_BOTTOM_KEYBOARD_OPEN()
                });
            }
        );
    },

    _slide_comment_input_field_down: function () {
        var $comment_creator_layout = this.$el.find('.comment_creator .creator_layout');

        $comment_creator_layout.animate(
            {
                bottom: this._POSITION_BOTTOM_KEYBOARD_CLOSE
            },
            this._ANIMATION_SPEED
        );
    },

    _close_all_delete_buttons: function () {
        $('.comment.deleting').removeClass('deleting');
    }
});

export const NotificationsPage = BaseToolbarNavPageLayout.extend({
    template: '#tpl_notifications_page',
    toolbarnav_title: function () {
        return _t('mobile_common_notifications');
    },
    is_top_level_page: true,
    toolbarnav_toggle_search: false,

    collection: null, // CommentsForUser

    regions: {
        r_comments_list: '.comments_list_container'
    },

    events: {
        'click .comments_set_read a': 'mark_all_as_read'
    },

    templateHelpers: function () {
        return {
            num_comments: this.collection.length,
            unread_count: $f.mobile.unread_notifications_count.get('count')
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
        var this_ = this;

        this.collection = this.collection || new CommentsForUser();
        showLoadingDialog();
        this.collection.fetch({
            success: function () {
                this_.render(); // need to re-render to make the "mark all as ready" button show up
                hideLoadingDialog();
            },
            error: function () {
                hideLoadingDialog();
            }
        });
    },

    onShow: function () {
        $f.application.vent.trigger('mobile:set_active_leftmenu_item', 'nav_notifications');
    },

    onRender: function () {
        $f.mobile.unread_notifications_count.fetch();

        this.r_comments_list.show(new CommentNotifications({ collection: this.collection }));
    },

    /**
     * Mark all comments for this user as read
     */
    mark_all_as_read: function () {
        if ($f.mobile.unread_notifications_count.get('count') === 0) {
            return false;
        }

        // Disable 'mark as read' button - doing this instead of calling render() so we don't have to re-render the whole list
        this.$el.find('.comments_set_read').addClass('disabled');

        this.collection.mark_all_as_read({
            success: function () {
                $f.mobile.unread_notifications_count.set('count', 0);
            }
        });

        return false;
    }
});

export const CommentNotifications = BaseToolbarNavList.extend({
    className: 'notifications_list',
    collection: null, // CommentsForUser
    tagName: 'ul',

    getEmptyView: function () {
        return EmptyListMessage.extend({
            icon_class: 'df-notifications',
            i18n_key_title: _t('mobile_notifications_empty_title'),
            i18n_key_message: _t('mobile_notifications_empty_message')
        });
    },

    getItemView: function (model) {
        switch (model.get('target').get('type')) {
            case 'task':
                return TaskNotification;
            case 'submission':
                return SubmissionNotification;
            case 'announcement':
                return AnnouncementNotification;
            default:
        }
    }
});

export const CommentsNotification = Backbone.Marionette.Layout.extend({
    template: '#tpl_comment_notification',
    model: null, // $f.web.models.Comment
    tagName: 'li',
    className: 'notification',

    events: {
        'click .go_to_comment': 'click_go_to_comment'
    },

    templateHelpers: function () {
        var date_created = moment(this.model.get('date_created'));
        var message = this.model.get_html_formatted_message({
            for_editing: false,
            disable_clicking: true
        });

        var account_name = null;
        if (this.model.get('target') && this.model.get('target').get('account')) {
            account_name = this.model.get('target').get('account').get('name');
        }

        return {
            date_created: date_created.format($f.utils.DATE_AND_TIME_NO_TZ_FMT),
            is_mention: !!this.model.get('mentions').get($f.active_user.id),
            is_unread: !this.model.get('user_info').get('has_read'),
            is_active: this.model.get('is_active'),
            account_name: account_name,
            target_title: this.model.get('target').get('name'),
            formatted_message: message
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        // Listen to unread status and re-render
        this.listenTo(this.model.get('user_info'), 'change', this.render);
    },

    click_go_to_comment: function (event) {
        var unread_notifications = this.model.collection.filter(function (model) {
            return model.get('user_info') && !model.get('user_info').get('has_read');
        });

        // if this is the only unread notification, set the count to 0 (hide the notification dot)
        // viewing the comment on the next page will hit the server
        if (unread_notifications.length === 1 && unread_notifications[0] === this.model) {
            $f.mobile.unread_notifications_count.set('count', 0);
        }

        this.go_to_comment();
    },

    go_to_comment: function () {
        throw new Error('Not implemented');
    },

    /**
     * Because go_to_comment uses the router which wipes our nav state, we need to manually update $f.mobile.nav
     */
    add_notifications_page_to_nav_history: function () {
        $f.mobile.nav._views.unshift(NotificationsPage);
        $f.mobile.nav._options.unshift({});
    }
});

export const TaskNotification = CommentsNotification.extend({
    go_to_comment: function () {
        var this_ = this;
        $f.window.app_router.show_single_task_with_comments(
            this.model.get('target').get('id'),
            this.model.get('id'),
            function () {
                $f.mobile.unread_notifications_count.fetch();
                this_.add_notifications_page_to_nav_history();
            }
        );

        return false;
    }
});

export const SubmissionNotification = CommentsNotification.extend({
    go_to_comment: function () {
        var this_ = this;
        $f.window.app_router.show_submission_with_comments(
            this.model.get('target').get('id'),
            this.model.get('id'),
            function () {
                this_.add_notifications_page_to_nav_history();
            }
        );

        return false;
    }
});

export const AttachmentItem = Backbone.Marionette.Layout.extend({
    template: '#tpl_attachment',
    model: null, // Attachment
    tagName: 'div',
    className: 'attachment',
    events: {
        'click .announcements_attachment': 'handle_attachment_click'
    },
    templateHelpers: function () {
        return {
            fileSize: $f.utils.format_bytes(this.model.get('file_size')),
            isImage: this.model.get('content_type').includes('image'),
            thumbnail: $f.storage.get_storage_full_url(this.model.get('path_medium'))
        };
    },
    handle_attachment_click: function () {
        var filename = this.model.get('file_name');
        var url = $f.storage.get_storage_full_url(this.model.get('path'));
        var is_image = this.model.get('content_type').indexOf('image') != -1;
        if (isWeb()) {
            if (is_image) {
                $f.mobile.nav.show_modal(ImagePreviewModal, {
                    src: url,
                    allow_delete: false
                });
            } else {
                window.open(url, '_blank');
            }
            return;
        }

        if (is_image) {
            var file_paths = this.model.collection
                .filter(function (file) {
                    return file.get('content_type').includes('image');
                })
                .map(function (image) {
                    return $f.storage.get_storage_full_url(image.get('path'));
                });
            CordovaPlugins().zencam.getZencam(
                function (urls) {
                    // Since we're just viewing the attachment, no success callback is needed.
                },
                function (error) {
                    $f.mobile.logging.log_error('Error while getting zencam plugin', error);
                    showErrorMessage('Unable to open ' + filename);
                },
                {
                    destinationType: CordovaPlugins().zencam.DestinationType.FILE_URI,
                    encodingType: CordovaPlugins().zencam.EncodingType.JPEG,
                    inputType: CordovaPlugins().zencam.InputType.FILE_ARRAY,
                    inputData: file_paths,
                    upperBound: 1000,
                    allowDelete: false,
                    strings: getZencamLocalizedStrings(),
                    selectedImageIndex: file_paths.indexOf(url),
                    compressionPercent: 90 // @author:david This should be 100 because we don't want to re-compress,
                    // but some Android devices will lock up to an infinite loop if compression
                    // is 100. Setting to 90 seems to work fine.
                }
            );
        } else {
            logMobileUsage('AnnouncementAttachmentAccessed', { url: url, filename: filename });
            toastNotification(_t('mobile_announcement_attachment_download', { filename: filename }));
            CordovaPlugins().zencam.viewDocumentRemote(
                {
                    path: url,
                    original_name: filename
                },
                function () {
                    // Nothing to do on success
                },
                function (error) {
                    $f.mobile.logging.log_error(JSON.stringify(error));
                    showErrorMessage('Unable to open ' + filename);
                }
            );
        }
    }
});

export const AttachmentsList = Backbone.Marionette.CollectionView.extend(
    {
        template: '#tpl_comments',
        collection: null, // Attachments
        tagName: 'div',
        className: 'attachments_container',

        getItemView: function (model) {
            return AttachmentItem;
        },
        initialize: function (options) {
            options = options || {};
            $.extend(this, options);
        }
    },
    {}
);

export const AnnouncementNotification = Backbone.Marionette.Layout.extend({
    template: '#tpl_announcement_notification',
    model: null, // $f.web.models.Comment
    tagName: 'li',
    className: 'notification',

    regions: {
        r_attachments_list: '.announcements_attachments'
    },

    events: {
        'click .read_message': 'handle_message_click'
    },

    templateHelpers: function () {
        var date_created = moment(this.model.get('date_created'));
        var company = this.model.get('company');
        var target = this.model.get('target');
        var message = this.model.get_html_formatted_message({
            for_editing: false,
            disable_clicking: true
        });
        message = window.linkifyHtml(message);
        var target_user = null;

        if (target && target.get('created_user')) {
            target_user = target.get('created_user');
        }

        return {
            date_created: date_created.format($f.utils.DATE_AND_TIME_NO_TZ_FMT),
            is_mention: !!this.model.get('mentions').get($f.active_user.id),
            is_unread: !this.model.get('user_info').get('has_read'),
            is_active: this.model.get('is_active'),
            is_open: this.model.get_is_open(),
            target_user: target_user,
            target_title: target.get('name'),
            formatted_message: message,
            show_brand: !_.isEmpty(company) && $f.active_company.get('id') !== company.id
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        // Listen to unread status and re-render
        this.listenTo(this.model.get('user_info'), 'change', this.render);
        this.listenTo(this.model, 'change:is_open', _.bind(this.handle_model_change_is_open, this));
    },

    handle_model_change_is_open: function (is_open) {
        if (is_open) {
            this.show_message();
        } else {
            this.hide_message();
        }
    },

    hide_message: function () {
        var this_ = this;
        var $message = $(this_.el).find('.announcement_message');

        $message.hide($f.shared.comments.utils.ANIMATION_SPEED, function () {
            this_.render();
        });
    },

    show_message: function () {
        var this_ = this;
        var $message = $(this.el).find('.announcement_message');

        $message.show($f.shared.comments.utils.ANIMATION_SPEED, function () {
            this_.render();
        });
    },

    handle_message_click: function (event) {
        event.stopPropagation();

        // Prevent toggle for links in message and attachments
        if ($(event.target).hasClass('linkified') || $(event.target).hasClass('ignore_close')) {
            return;
        }
        var previousOpenState = this.model.get_is_open();

        this.model.set_is_open(!previousOpenState);
    },

    onRender: function () {
        if (!this.model.get('target').get('attachments').length) {
            // Don't render r_attachments_list if there are no attachments
            return;
        }
        this.r_attachments_list.show(
            new AttachmentsList({
                collection: new AnnouncementAttachments(this.model.get('target').get('attachments'))
            })
        );
    }
});
